import type {
  CreatePoiPayload,
  IPoiTranslation,
  PoiBasicInfoState,
  PoiLocationState,
  PoiType,
  UpdatePoiPayload,
} from '@/shared/api/types/poi-types'

export interface BuildPoiPayloadInput {
  /** `basicInfo.type` already validated (non-empty). */
  type: PoiType
  basicInfo: PoiBasicInfoState
  location: PoiLocationState
  tenantDestinationId: string
  /** Translations already trimmed by `normalizePoiTranslations`. */
  translations: IPoiTranslation[]
  /** Successfully uploaded image URLs. */
  bannerUrls: string[]
}

/** The address is optional: an empty/blank one is left out instead of being sent as "". */
function addressField(location: PoiLocationState): { address?: string } {
  const address = location.address?.trim()
  return address ? { address } : {}
}

/** Body of `POST /pois`. */
export function buildCreatePoiPayload(
  input: BuildPoiPayloadInput & { tenantId: string; isActive: boolean },
): CreatePoiPayload {
  const category = input.basicInfo.category.trim()
  return {
    tenantId: input.tenantId,
    tenantDestinationId: input.tenantDestinationId,
    localizedData: input.translations,
    latitude: input.location.latitude,
    longitude: input.location.longitude,
    type: input.type,
    range: input.location.range,
    ...addressField(input.location),
    popupAd: input.basicInfo.popupAd,
    ...(category ? { category } : {}),
    banner: input.bannerUrls,
    audio: [],
    isActive: input.isActive,
  }
}

/** Body of the location section save. */
export function buildLocationUpdatePayload(location: PoiLocationState): UpdatePoiPayload {
  return {
    latitude: location.latitude,
    longitude: location.longitude,
    range: location.range,
    ...addressField(location),
  }
}

/** Body of the basic-info section save. */
export function buildBasicInfoUpdatePayload(
  basicInfo: PoiBasicInfoState,
  type: PoiType,
  tenantDestinationId: string,
): UpdatePoiPayload {
  return {
    tenantDestinationId,
    type,
    popupAd: basicInfo.popupAd,
    category: basicInfo.category.trim(),
    range: basicInfo.range,
  }
}
